import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Subscription, merge } from "rxjs";
import { TS1_REMINDER_NOTES_MAX_LENGTH } from "../ts1-form.factories";
import { Ts1ReminderNotesModalComponent } from "../ts1-reminder-notes-modal/ts1-reminder-notes-modal.component";

@Component({
	selector: "app-ts1-form-config",
	templateUrl: "./ts1-form-config.component.html",
	styleUrls: ["./ts1-form-config.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1FormConfigComponent implements OnInit, OnDestroy {
	@Input({ required: true }) reminderNotesEnabled!: UntypedFormControl;
	@Input({ required: true }) reminderNotesTemplate!: UntypedFormControl;
	@Input() readOnly = false;

	private valueSub?: Subscription;

	constructor(
		private dialog: MatDialog,
		private cd: ChangeDetectorRef,
	) {}

	ngOnInit(): void {
		this.valueSub = merge(this.reminderNotesEnabled.valueChanges, this.reminderNotesTemplate.valueChanges).subscribe(
			() => this.cd.markForCheck(),
		);
	}

	ngOnDestroy(): void {
		this.valueSub?.unsubscribe();
	}

	get isReminderEnabled(): boolean {
		return this.reminderNotesEnabled?.value === true;
	}

	get templatePreview(): string {
		const value = (this.reminderNotesTemplate?.value ?? "").toString().trim();
		if (!value) return "";
		return value.length > 80 ? `${value.slice(0, 80)}…` : value;
	}

	onReminderNotesToggle(checked: boolean): void {
		if (this.readOnly) return;
		this.reminderNotesEnabled.setValue(checked);
		this.reminderNotesEnabled.markAsDirty();
	}

	openReminderNotesEditor(): void {
		if (this.readOnly) return;
		const dialogRef = this.dialog.open(Ts1ReminderNotesModalComponent, {
			panelClass: ["ts1-reminder-notes-modal-panel", "ts1-reminder-notes-modal"],
			width: "720px",
			hasBackdrop: true,
			data: {
				value: (this.reminderNotesTemplate?.value ?? "").toString(),
			},
		});

		dialogRef.afterClosed().subscribe((result: string | null) => {
			if (result === null) return;
			this.reminderNotesTemplate.setValue(result.slice(0, TS1_REMINDER_NOTES_MAX_LENGTH));
			this.reminderNotesTemplate.markAsDirty();
		});
	}
}
